export enum PreviewOptionName {
  DESKTOP = 'Desktop',
  IPAD = 'iPad',
  MOBILE = 'Mobile',
}
